import { API_BASE,axiosApi } from "../config"
import {
  GetPaymentIntentReturnInterface,
  HelloReturnInterface
} from "../types"

export const hello = async (body: { n: number }): Promise<HelloReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/hello`, body)).data
}


export const getPaymentIntent = async (body: {
  cents:number
  currency:string
  metadata: {
    firstname: string,
    lastname:string
    
  },
}): Promise<GetPaymentIntentReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getPayment_Intent`,body)).data
}

// Generate unsubscribe URL with token
export const generateUnsubscribeUrl = async (body: {
  email: string
  baseUrl?: string
}): Promise<{
  code: number
  message: string
  data?: {
    email: string
    unsubscribeUrl: string
    expiresIn: string
  }
}> => {
  return (await axiosApi.post(`${API_BASE}/generate-unsubscribe-url`, body)).data
}

// Get unsubscribed emails for admin
export const getUnsubscribedEmails = async (params: {
  page?: number
  pageSize?: number
  search?: string
}): Promise<{
  code: number
  message: string
  data?: {
    unsubscribes: Array<{
      email: string
      unsubscribedAt: string
      ipAddress: string
      userAgent: string
      resubscribedAt: string | null
    }>
    pagination: {
      page: number
      pageSize: number
      total: number
      totalPages: number
    }
  }
}> => {
  const queryParams = new URLSearchParams()
  if (params.page) queryParams.append('page', params.page.toString())
  if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString())
  if (params.search) queryParams.append('search', params.search)
  
  return (await axiosApi.get(`${API_BASE}/unsubscribed-emails?${queryParams.toString()}`)).data
}
